module.exports = __webpack_public_path__ + "static/WEB1-5b175b7b73706bf1f1f56d13ad4245d4.jpg";